/* eslint ember/no-new-mixins:"off" */
import { computed, get } from '@ember/object';
import Mixin from '@ember/object/mixin';
import { escapeRegExp } from '@square/dashboard-utilities/utils/string';
export default Mixin.create({
  // Properties to use when searching
  searchProperties: computed(function () {
    return [];
  }),
  // Filter a list of entities based on a textual query and a set of properties.
  filterObjectsBySearch(entities, query) {
    if (!query || query.length <= 0) {
      return entities;
    }
    const searchRegex = new RegExp(escapeRegExp(query), 'i');
    return entities.filter(entity => {
      return this.searchProperties.some(function (property) {
        const entityPropertyValue = get(entity, property);
        const value = entityPropertyValue && (typeof entityPropertyValue === 'string' ? entityPropertyValue : entityPropertyValue.toString());
        return value && (value.match && value.match(searchRegex) || value.some && value.some(innerValue => innerValue && innerValue.match(searchRegex)));
      });
    });
  }
});